import config from '../../../app/config/consumerPortal.default.json5';

export const sendGoogleAnalyticsEvent = ({
  event_name,
  event_category = 'event_category',
  event_label='event_label',
  }, isPerProduct=false)=>{
  let eventName = event_name;

  // if the event is not configured in Presentation Metadata, we do not record that event.
  if (!eventName){
    return;
  }

  if (isPerProduct){
    const gaProductVersion = localStorage.getItem(GA_PRODUCT_VERSION_KEY);
    const gaProductCodeKey = localStorage.getItem(GA_PRODUCT_CODE_KEY)
    const index = config.googleAnalyticsProductConfig.findIndex(v=>v.productVersionId === gaProductVersion);
    if (index !== -1){
      const productEventName = config.googleAnalyticsProductConfig[index].productEventName;
      productEventName ? (eventName += '_' + productEventName) : null;
    }else {
      gaProductCodeKey ? (eventName += '_' + gaProductCodeKey) : null;
    }
  }else {
    //recording a total number of Email Quote, event Name is "Total_Email_Quote"
    if (event_name === GA_CONFIGURATION.Email_Quote){
      eventName = "Total_"+eventName;
    }
  }

  window.gtag("event", eventName, {
    event_category: event_category,
    event_label: event_label,
  });
}

export const GA_PRODUCT_CODE_KEY = 'GA_PRODUCT_CODE_KEY';
export const GA_PRODUCT_VERSION_KEY = 'GA_PRODUCT_CODE_VERSION_KEY';

export const GA_CONFIGURATION = {
  // The number of times that consumers chose to be referred to an agent.
  Refer_To_Agent:config.googleAnalyticsEvents.eventReferToAgent,

  //The number of policies started.Google Analytics tracks this event by product.
  Quote_Started:config.googleAnalyticsEvents.eventQuoteStarted,

  //The number of times that consumers selected the email quote option.
  Email_Quote:config.googleAnalyticsEvents.eventEmailQuote,

  //The number of times that consumers declined/accepted the consumer consent.Google Analytics tracks this event by product.
  Decline_Consumer_Consent:config.googleAnalyticsEvents.eventDeclineConsumerConsent,
  Accept_Consumer_Consent:config.googleAnalyticsEvents.eventAcceptConsumerConsent,

  //The number of times that consumers submitted payment on a policy.
  Payment_Method:config.googleAnalyticsEvents.eventPaymentMethod,

  //The number of times that policies were referred to an agent for processing or approval.Google Analytics tracks this event by product.
  Submission:config.googleAnalyticsEvents.eventSubmission,

  //The number of issued policies.Google Analytics tracks this event by product.
  Issuance:config.googleAnalyticsEvents.eventIssuance,

  //The number of times that consumers selected the option to create an account in the Service Portal.
  Link_Account_Request:config.googleAnalyticsEvents.eventLinkAccountRequest,

  //The number of times that consumers visited the FAQ page.
  FAQ:config.googleAnalyticsEvents.eventFAQ,
}